/* Regenis upsell v12.
   v12 (2026-07-16): ATC-window guard. During add-to-cart the cart is
   mid-composition (controller pre-adds ebook+protection, Kaching's main add is
   still in flight) -- a sync() fired then read an addons-only cart and (a)
   painted "Check out - $3.95" / savings $9.99 from the half state, and (b) the
   v10 stray-addon purge could REMOVE the ebook+protection racing the main add.
   sync now defers while window.__rgAtcAt (set by the controller's fetch
   wrapper) is fresh or rg-atc-pending is up; the purge re-reads the cart 700ms
   later and only fires if it is STILL addons-only. partialSwap re-asserts the
   controller's computed savings in the same task so server-rendered totals can
   never blip a transient number.
   v11 (2026-07-15): sync() defers while window.__rgxHold is set (cart controller
   mid-commit) so stale cart reads can never repaint the checkout label.
   v10 (2026-07-14): blank-drawer fix. The v9 preselect auto-added Shipping
   Protection on sync() regardless of what else was in the cart, so an empty cart
   became a $3.95 addon-only cart. cart != empty, so the drawer's empty state
   never rendered; the lone addon line item is hidden by upsell-block's
   `display:none` rule -> a BLANK drawer reading "1 items" with a live Check out
   button for $3.95 of nothing. Now the auto-add requires realCount > 0, and an
   addon left alone in the cart is purged (preselect re-arms for next time).
   v8 (2026-07-09): freeze fix. The v7 body-wide MutationObserver reacted to EVERY
   page mutation (the drawer reservation timer alone ticks 1/s), each reaction ran
   sync() -> fetch /cart.js -> innerHTML rewrites, and renderDealPills nuked the
   whole .rgx-deal-pills holder -- including the sale pill rgx-extras injects into
   it -- so extras re-added it, which re-fired this observer: a perpetual
   fetch/rewrite loop that never settled (page + theme editor "freezing"). Now:
   (a) observer records are filtered -- only mutations inside cart-drawer count,
   and the timer / pill containers / our own writes are ignored; (b) all DOM
   writes are wrapped in selfWrite() so our own mutations can't re-trigger us;
   (c) deal pills live in their own .rgx-deal-pills holder and the sale pill in a
   sibling .rgx-sale-pills holder owned by rgx-extras -- neither script touches
   the other's node again; (d) classList/aria writes are guarded so no-op calls
   stop rewriting attributes (observer fan-out to Clarity/Kaching/pixel).
   v7: Rapid-click-proof toggles: every click flips the switch instantly and records
   intent in `desired`; a 300ms-debounced committer sends only the FINAL state and
   re-commits if intent changed mid-flight. The background reconciler (sync) is
   barred from touching any switch that is committing or was clicked in the last
   1.5s, so stale cart reads can never bounce the knob back. */
(function () {
  var addBusy = false, syncT = null, normBusy = false, obsT = null, purgeBusy = false;
  var desired = {}, committing = {}, commitT = {}, lastTouch = {};
  var writeDepth = 0;
  /* v12: response-order guard. Every user action and every issued read/write
     bumps `seq`; a response only gets to paint if nothing newer was issued
     while it was in flight (stale /cart.js and sections responses landing
     out of order briefly showed the PREVIOUS toggle state's numbers). */
  var seq = 0;

  /* Marks our own DOM writes so the body observer can ignore the mutation
     records they queue. Observer callbacks run as microtasks at the end of the
     current task -- before the setTimeout(0) below -- so the flag is still up
     when those records are delivered. */
  function selfWrite(fn) {
    writeDepth++;
    try { fn(); } finally { setTimeout(function () { writeDepth--; }, 0); }
  }

  /* never rebuild drawer sections while the shopper is mid-click-burst
     (shares the cart controller's click timestamp); the swap content stays
     valid, applying it 200ms later is invisible */
  function whenClickFree(fn) {
    var last = window.__rgLastClick || 0;
    if (Date.now() - last < 400) { setTimeout(function () { whenClickFree(fn); }, 180); return; }
    fn();
  }

  function $drawer() { return document.querySelector('cart-drawer'); }

  function sectionSpecs() {
    var d = $drawer();
    try { if (d && d.getSectionsToRender) return d.getSectionsToRender(); } catch (e) {}
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }
  function sectionIds() { return sectionSpecs().map(function (s) { return s.id; }); }

  function optimisticBump(up, on) {
    try {
      var priceEl = up.querySelector(".upsell__price .regular-price") || up.querySelector(".regular-price");
      if (!priceEl) return;
      var cents = Math.round(parseFloat((priceEl.textContent || "").replace(/[^0-9.]/g, "")) * 100);
      if (!cents) return;
      document.querySelectorAll("cart-drawer [name=\"checkout\"]").forEach(function (btn) {
        var span = null;
        for (var i = 0; i < btn.children.length; i++) { var c = btn.children[i]; if (c.tagName === "SPAN" && (c.textContent || "").trim()) { span = c; break; } }
        var el = span || btn;
        var m = (el.textContent || "").match(/([0-9,]+\.[0-9]{2})/);
        if (!m) return;
        var cur = Math.round(parseFloat(m[1].replace(/,/g, "")) * 100);
        var next = on ? cur + cents : cur - cents;
        if (next < 0) next = 0;
        var out = "Check out \u2022 " + money(next);
        if (el.innerHTML !== out) selfWrite(function () { el.innerHTML = out; });
      });
    } catch (e) {}
  }

  function money(cents) {
    var n = (cents / 100).toFixed(2);
    return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function silentSwap(state) {
    if (!state || !state.sections) return state;
    try {
      whenClickFree(function () { selfWrite(function () {
        sectionSpecs().forEach(function (section) {
          var html = state.sections[section.id];
          if (!html) return;
          var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (!target) return;
          var src = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
          if (src){ if (window.__rgMorphInner) window.__rgMorphInner(target, src); else target.innerHTML = src.innerHTML; }
        });
      }); });
    } catch (e) {}
    return state;
  }

  function partialSwap(state) {
    if (!state || !state.sections) return state;
    try {
      var specs = sectionSpecs();
      var drawerSpec = null;
      specs.forEach(function (s) { if (s.id === 'cart-drawer' || s.selector === '#CartDrawer') drawerSpec = s; });
      whenClickFree(function () { selfWrite(function () {
        specs.forEach(function (section) {
          if (section === drawerSpec) return;
          var html = state.sections[section.id];
          if (!html) return;
          var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (!target) return;
          var src = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
          if (src){ if (window.__rgMorphInner) window.__rgMorphInner(target, src); else target.innerHTML = src.innerHTML; }
        });
        var html = drawerSpec ? state.sections[drawerSpec.id] : null;
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['.cart-progress', '.cart-drawer__totals'].forEach(function (sel) {
            var fresh = doc.querySelector(sel);
            var old = document.querySelector('cart-drawer ' + sel);
            if (fresh && old){ if (window.__rgMorph) window.__rgMorph(old, fresh); else old.replaceWith(fresh); }
          });
          /* v12: server-rendered totals can carry a transient number (cart read
             mid-flow) -- re-assert the controller's computed savings in the
             SAME task so it is never visible. */
          try { if (window.__rgPaintSavings) window.__rgPaintSavings(); } catch (e) {}
        }
      }); });
    } catch (e) { return silentSwap(state); }
    return state;
  }

  function renderOpen(state) {
    var d = $drawer();
    if (d && d.renderContents && state && state.sections) {
      try {
        var ok = false;
        selfWrite(function () { d.renderContents(state); ok = true; });
        if (ok) return state;
      } catch (e) {}
    }
    return silentSwap(state);
  }

  function setQty(id, qty) {
    var updates = {}; updates[id] = qty;
    var s = ++seq;
    return postJSON('/cart/update.js', {
      updates: updates,
      sections: sectionIds(),
      sections_url: window.location.pathname
    }).then(function (state) { return s === seq ? partialSwap(state) : state; });
  }

  function addItem(id) {
    return postJSON('/cart/add.js', {
      items: [{ id: Number(id), quantity: 1 }],
      sections: sectionIds(),
      sections_url: window.location.pathname
    }).then(renderOpen);
  }

  function toggleUpsells() {
    return Array.prototype.filter.call(document.querySelectorAll('cart-drawer-upsell'), function (u) {
      return u.querySelector('.upsell__toggle-switch');
    });
  }

  function isHot(id) {
    return !!committing[id] || (Date.now() - (lastTouch[id] || 0)) < 1500;
  }

  function setSwitch(btn, on) {
    if (btn.classList.contains('rgx-on') !== on) btn.classList.toggle('rgx-on', on);
    if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', String(on));
  }

  function applyDesired() {
    toggleUpsells().forEach(function (u) {
      var id = Number(u.dataset.id);
      if (!(id in desired)) return;
      /* v11: only re-assert FRESH user intent (clicked <1.5s ago or mid-commit).
         sync() also mirrors server state into `desired`, and applying that stale
         mirror onto a freshly swapped-in section stomped the server-rendered
         switch state -- the preselected ebook rendered ON by upsell-block.liquid
         visibly flipped OFF->ON ~0.5s after the drawer opened. The server render
         is the truth; only a live click may override it. */
      if (!isHot(id)) return;
      var btn = u.querySelector('.upsell__toggle-switch');
      setSwitch(btn, !!desired[id]);
    });
  }

  function scheduleCommit(id) {
    clearTimeout(commitT[id]);
    commitT[id] = setTimeout(function () { commit(id); }, 110); // rgx: faster toggle->checkout/bar update
  }

  function commit(id) {
    if (committing[id]) return;
    var want = desired[id] ? 1 : 0;
    committing[id] = true;
    var s = seq;   /* setQty bumps it; capture the post-bump value below */
    setQty(id, want).then(function (cart) {
      committing[id] = false;
      var nowWant = desired[id] ? 1 : 0;
      if (nowWant !== want) { scheduleCommit(id); return; }
      if (cart && seq === s + 1) { setCheckoutLabel(cart); renderDealPills(cart); }
      applyDesired();
      syncSoon();
    }).catch(function () { committing[id] = false; syncSoon(); });
  }

  function neutralize(scope) {
    (scope || document).querySelectorAll('.upsell__add-btn[type="submit"]').forEach(function (b) {
      b.type = 'button';
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var addBtn = t.closest('.upsell__add-btn');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (addBusy) return;
      var upA = addBtn.closest('cart-drawer-upsell');
      var idA = upA && upA.dataset.id;
      if (!idA) return;
      addBusy = true;
      addBtn.classList.add('loading');
      addItem(idA).then(function () { addBusy = false; addBtn.classList.remove('loading'); syncSoon(); })
        .catch(function () { addBusy = false; addBtn.classList.remove('loading'); });
      return;
    }

    var tog = t.closest('.upsell__toggle-switch');
    if (tog) {
      e.preventDefault();
      e.stopPropagation();
      var up = tog.closest('cart-drawer-upsell');
      var id = up && Number(up.dataset.id);
      if (!id) return;
      seq++;   /* v12: user intent invalidates every in-flight response */
      var cur = (id in desired) ? !!desired[id] : tog.classList.contains('rgx-on');
      var next = !cur;
      desired[id] = next;
      lastTouch[id] = Date.now();
      setSwitch(tog, next);
      optimisticBump(up, next);
      scheduleCommit(id);
    }
  }, true);

  function setCheckoutLabel(cart) {
    var total = cart.total_price || 0;
    var lineSum = (cart.items || []).reduce(function (s, i) { return s + (i.final_line_price || 0); }, 0);
    if (!total && lineSum > 0) total = lineSum;
    var orig = cart.original_total_price || 0;
    var html = 'Check out \u2022 ' + money(total);
    var hc = document.querySelector('cart-drawer .drawer__heading');
    /* v12: the "N bags" heading is owned by the cart controller (bag math !=
       item_count) -- only touch a heading that uses a plain item count. */
    if (hc && !/bags?/i.test(hc.textContent)) {
      var ht = hc.textContent.replace(/\d+/, String(cart.item_count || 0));
      if (ht !== hc.textContent) selfWrite(function () { hc.textContent = ht; });
    }
    document.querySelectorAll('cart-drawer [name="checkout"]').forEach(function (btn) {
      var target = null;
      for (var i = 0; i < btn.children.length; i++) {
        var c = btn.children[i];
        if (c.tagName === 'SPAN' && (c.textContent || '').trim()) { target = c; break; }
      }
      var el = target || btn;
      if (el.innerHTML !== html) selfWrite(function () { el.innerHTML = html; });
    });
  }

  /* v8: this holder now contains ONLY the auto (Kaching/discount-title) pills.
     The sale pill lives in a sibling .rgx-sale-pills holder owned by
     rgx-extras.js -- we never read, compare against, or remove it. */
  function renderDealPills(cart) { return;
  }

  function sync() {
    /* v11 (2026-07-15): the cart controller in snippets/cart-drawer.liquid sets
       window.__rgxHold while it has uncommitted stepper state. A sync fired then
       would read a STALE /cart.js and repaint the checkout label with old numbers
       (the mid-spam flicker). Defer until it settles. */
    if (window.__rgxHold) { clearTimeout(syncT); syncT = setTimeout(sync, 250); return Promise.resolve(); }
    /* v12: never read/normalize/purge the cart during the ATC window -- it is
       mid-composition and every conclusion drawn from it is wrong. */
    if ((Date.now() - (window.__rgAtcAt || 0)) < 4000 || document.querySelector('cart-drawer.rg-atc-pending')) {
      clearTimeout(syncT); syncT = setTimeout(sync, 500); return Promise.resolve();
    }
    var s = ++seq;
    return getCart().then(function (cart) {
      if (s !== seq) return cart;   /* something newer issued while we read */
      var inCart = {}, qty = {};
      (cart.items || []).forEach(function (it) { inCart[it.id] = 1; qty[it.id] = (qty[it.id] || 0) + it.quantity; });
      var overstock = [];
      /* v10: an addon must never be the only thing in the cart. The drawer hides
         addon line items via CSS, so an addon-only cart renders as a BLANK drawer
         that still offers checkout ($3.95 for nothing). Count the real (non-upsell)
         items so we can skip the preselect auto-add on an empty cart, and purge an
         addon that ends up alone. */
      var upsellIds = {};
      toggleUpsells().forEach(function (u) { upsellIds[Number(u.dataset.id)] = 1; });
      var realCount = 0;
      (cart.items || []).forEach(function (it) { if (!upsellIds[it.id]) realCount++; });

      toggleUpsells().forEach(function (u) {
        var id = Number(u.dataset.id);
        var btn = u.querySelector('.upsell__toggle-switch');
        var serverOn = !!inCart[id];
        /* v9: honor data-selected preselect -- auto-add once per tab session,
           never re-add after the user removes it.
           v10: ...and never into a cart with no real product in it. */
        if (u.dataset.selected === 'true' && realCount > 0 && !serverOn && !isHot(id) &&
            !sessionStorage.getItem('rgx-presel-' + id)) {
          sessionStorage.setItem('rgx-presel-' + id, '1');
          desired[id] = true;
          setSwitch(btn, true);
          scheduleCommit(id);
          return;
        }
        if (!isHot(id)) desired[id] = serverOn;
        var on = (id in desired) ? !!desired[id] : serverOn;
        setSwitch(btn, on);
        if (!isHot(id) && serverOn && qty[id] > 1) overstock.push(id);
      });

      /* v10: nothing but addons left -> drop them so the cart is genuinely empty
         and the drawer's empty state renders. Re-arm the preselect so the addon
         comes back on its own once a real product is added again. */
      if (realCount === 0 && !purgeBusy) {
        var strays = Object.keys(inCart).filter(function (id) {
          return upsellIds[id] && !isHot(id);
        });
        if (strays.length) {
          purgeBusy = true;
          /* v12: verify before purging. A main add can land between our read
             and this write (the read raced an ATC) -- re-read after 700ms and
             only purge if the cart is STILL addons-only. */
          return new Promise(function (res) { setTimeout(res, 700); }).then(getCart).then(function (c2) {
            var real2 = 0;
            ((c2 && c2.items) || []).forEach(function (it) { if (!upsellIds[it.id]) real2++; });
            var strays2 = ((c2 && c2.items) || []).filter(function (it) {
              return upsellIds[it.id] && !isHot(it.id);
            }).map(function (it) { return it.id; });
            if (real2 > 0 || !strays2.length || (Date.now() - (window.__rgAtcAt || 0)) < 4000) {
              purgeBusy = false; return;
            }
            var purge = {};
            strays2.forEach(function (id) {
              purge[id] = 0;
              delete desired[id];
              try { sessionStorage.removeItem('rgx-presel-' + id); } catch (e) {}
            });
            return postJSON('/cart/update.js', {
              updates: purge,
              sections: sectionIds(),
              sections_url: window.location.pathname
            }).then(partialSwap).then(function () { purgeBusy = false; });
          }).catch(function () { purgeBusy = false; });
        }
      }

      if (overstock.length && !normBusy) {
        normBusy = true;
        var updates = {}; overstock.forEach(function (id) { updates[id] = 1; });
        postJSON('/cart/update.js', { updates: updates, sections: sectionIds(), sections_url: window.location.pathname })
          .then(partialSwap).then(function () { normBusy = false; syncSoon(); })
          .catch(function () { normBusy = false; });
      }
      setCheckoutLabel(cart);
      renderDealPills(cart);
      return cart;
    }).catch(function () {});
  }
  function syncSoon() { clearTimeout(syncT); syncT = setTimeout(sync, 140); }

  /* v8: only mutations that (a) are not ours, (b) are not the reservation /
     banner timers or the pill holders, and (c) happen inside cart-drawer (or add
     a cart-drawer / upsell node to the page) count as relevant. Everything else
     -- theme-editor section re-renders, page timers, other apps -- is ignored. */
  var IGNORE_SEL = '.cart-timer, .rgx-deal-pills, .rgx-sale-pills, #rgx-readbar, [class*="rg_countdown_timer_box_"]';
  function relevantRecords(muts) {
    if (writeDepth > 0) return false;
    for (var i = 0; i < muts.length; i++) {
      var rec = muts[i];
      var t = rec.target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (!el || !el.closest) continue;
      if (el.closest(IGNORE_SEL)) continue;
      if (el.closest('cart-drawer')) return true;
      for (var j = 0; j < rec.addedNodes.length; j++) {
        var n = rec.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('cart-drawer')) || (n.querySelector && n.querySelector('cart-drawer, cart-drawer-upsell'))) return true;
      }
    }
    return false;
  }

  function init() {
    neutralize(document);
    sync();
    if (!document.body.__rgxUpsellObs) {
      document.body.__rgxUpsellObs = true;
      new MutationObserver(function (muts) {
        if (!relevantRecords(muts)) return;
        applyDesired();
        clearTimeout(obsT);
        obsT = setTimeout(function () { neutralize(document); syncSoon(); }, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

